<template>
  <!-- --bookable-cell-display is used in FullCalendarEvent component -->
  <section
    ref="fullCalendar"
    class="fc fc-container"
    :style="`--das-fc-day-width: ${dayCellWith}px; --bookable-cell-display: ${
      hideBookableCell ? 'none' : 'block'
    }`"
    :class="displayHour ? 'fc-display-hour' : 'fc-display-day'"
  >
    <div class="fc-sidebar-header">
      <div class="fc_sidebar-cell fc-cell--item">
        <div class="fc-cell">
          <span class="fc-cell-content"></span>
        </div>
        <!-- <div class="fc-cell">
          <span class="fc-cell-content">Ngày</span>
        </div> -->
      </div>
      <div class="fc-sidebar-cell fc-cell--item">
        <div class="fc-cell">
          <span class="fc-cell-content">Phòng</span>
        </div>
        <!-- <div class="fc-cell">
          <span class="fc-cell-content">Trạng thái</span>
        </div> -->
      </div>
    </div>
    <div
      ref="fcHeader"
      style="z-index: 20; position: relative"
      class="fc-datagrid-header"
      @scroll="onHeaderScroll"
    >
      <div
        v-for="date in viewDates"
        :key="date"
        class="fc-datagrid-header-date"
      >
        <div
          :class="
            currentDate.format('YYYY-MM-DD') === date
              ? 'fc-cell--today'
              : 'fc-cell--date'
          "
          class="fc-cell fc-datagrid-header-date-cell"
        >
          <div class="fc-cell-content">
            <div class="fc-datagrid-header-label">
              {{ date.split('-')[2] + '-' + date.split('-')[1] }}
            </div>
          </div>
        </div>
        <div :key="date" class="fc-cell">
          <div class="fc-cell--hours-group">
            <template v-for="hour in viewHours">
              <div :key="hour" class="fc-cell-content fc-cell-hour">
                <span>{{ hour }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div ref="fcSidebar" class="fc-sidebar-days" @scroll="onSidebarScroll">
      <template v-for="group in schedule">
        <div :key="group.room_level_id" class="fc-sidebar-cell">
          <div
            class="fc-cell fc-cell--group"
            @click="group.toggled = !group.toggled"
          >
            <div class="fc-cell-content">
              <span class="fc_icon-group-toggle">
                <i v-if="group.toggled" class="el-icon-remove" />
                <i v-else class="el-icon-circle-plus" />
              </span>
              {{ group.room_level_code }}
            </div>
          </div>
        </div>
        <template v-if="group.toggled">
          <template v-for="room in group.room_list">
            <div :key="room.name" class="fc-cell--item">
              <div class="fc-cell">
                <div class="fc-cell-content">
                  <div class="fc-cell_room-num">{{ room.room_num }}</div>
                </div>
              </div>
              <!-- <div class="fc-cell" :style="getStatusStyle(room.status)">
                <div class="fc-cell-content">
                  <div class="schedule-room-status">
                    <span class="schedule-room-status_indicator"></span>
                    {{ room.status }}
                  </div>
                </div>
              </div> -->
            </div>
          </template>
        </template>
      </template>
    </div>

    <div
      ref="fcContent"
      class="fc-datagrid-days"
      :class="isDayGridEnabled ? 'fc-datagrid-days--day-grid-enabled' : ''"
      @scroll="onContentScroll"
    >
      <div style="position: relative">
        <div class="fc-now-indicator" :style="nowStyle">
          <div class="fc-now-indicator_time">
            {{ nowLabel }}
          </div>
        </div>
        <div class="fc-time-indicators">
          <div
            v-for="date in viewDates"
            :key="`${date}`"
            class="fc-row"
            style="width: var(--das-fc-day-width)"
          >
            <template v-for="hour in viewHours">
              <span :key="`${date}-${hour}`" class="fc-time-indicator"></span>
            </template>
          </div>
        </div>
        <div style="z-index: 10; position: relative">
          <template v-for="group in schedule">
            <div
              :key="`room-type-${group.room_level_id}`"
              class="fc-row fc-row-group"
            >
              <template v-for="date in viewDates">
                <div
                  :key="date"
                  class="fc-cell fc-cell--group"
                  style="width: var(--das-fc-day-width)"
                >
                  <div class="fc-cell-content">
                    {{ group[date].room_available }}
                  </div>
                </div>
              </template>
            </div>
            <template v-if="group.toggled">
              <div
                v-for="room in group.room_list"
                :key="`room-${room.room_id}`"
                class="fc-row fc-cell"
                style="position: relative"
              >
                <div class="fc-event-group">
                  <template v-for="event in room.type">
                    <FullCalendarEvent
                      :key="`room-${room.room_num}_event-${event.booking_id}`"
                      :display-hour="displayHour"
                      :start-date-object="startDateObject"
                      :event="event"
                      :user-groups="userGroups"
                      :day-cell-with="dayCellWith"
                      @viewBooking="onViewBooking"
                    ></FullCalendarEvent>
                  </template>
                </div>
                <div
                  v-for="date in viewDates"
                  ref="dateCell"
                  :key="date"
                  :class="
                    date === currentDate.format('YYYY-MM-DD')
                      ? 'fc-cell--today'
                      : 'fc-cell'
                  "
                  class="fc-cell--hours-group"
                  @click="
                    event =>
                      onAddSelectedCell(
                        { ...room, people_num: group?.people_num ?? 1 },
                        date,
                        event
                      )
                  "
                >
                  <!-- <template v-for="hour in viewHours">
                    <div :key="hour" class="fc-cell-hour"></div>
                  </template> -->
                </div>
              </div>
            </template>
          </template>
          <template v-for="selectedDay in selectedRooms">
            <template v-for="(day, index) in selectedDay.days">
              <FullCalendarDayCell
                :key="`room-${selectedDay.room.room_num}_day-${day.start.format(
                  'YYYY-MM-DD'
                )}`"
                :day="day"
                :min-day-cell-width="minDayCellWidth"
                @cellRemoved="onRemoveSelectedRoom(selectedDay, index)"
              ></FullCalendarDayCell>
            </template>
          </template>
          <!-- <FullCalendarDayCell
            v-for="selectedRoom in selectedRooms"
            :key="`selected-room-${selectedRoom.roomId}-${selectedRoom.startDate}`"
            :start-date-object="startDateObject"
            >key</FullCalendarDayCell
          > -->
        </div>
      </div>
    </div>
    <BookingRoomFormDialog
      v-model="isBookingRoomDialogOpened"
      :data="roomBooking"
      @refresh="onRefresh"
    ></BookingRoomFormDialog>
  </section>
</template>
<script>
import { getUserDetailApi } from '@/api/profile/profile'
import { newDateFromLocal, parseDateTimeToLocal } from '@/utils/date'

import FullCalendarEvent from './FullCalendarEvent.vue'
import BookingRoomFormDialog from '@/components/resources/booking/BookingRoomFormDialog.vue'
import FullCalendarDayCell from './FullCalendarDayCell.vue'
import { notifyError } from '@/utils/toast'
export default {
  components: {
    BookingRoomFormDialog,
    FullCalendarEvent,
    // eslint-disable-next-line vue/no-unused-components
    FullCalendarDayCell
  },
  props: {
    hideBookableCell: {
      required: true,
      default: false
    },
    displayHour: {
      default: false
    },
    displayDate: {
      default: null
    },
    schedule: {
      required: true
    },
    startDate: null,
    totalDays: null,
    isDayGridEnabled: {
      default: true
    }
  },
  data() {
    return {
      currentDate: this.$moment(newDateFromLocal(new Date())),
      roomBooking: {},
      isBookingRoomDialogOpened: false,
      contentLastScrollTop: 0,
      contentLastScrollLeft: 0,
      preventEvent: false,
      startDateObject: new Date(),
      nowTimer: null,
      nowLabel: null,
      nowStyle: null,
      minDayCellWidth: 0,
      selectedRooms: [],
      userGroups: []
    }
  },
  computed: {
    dayCellWith() {
      const minWidth = this.minDayCellWidth
      // return Math.max(this.displayHour ? 600 : 120, minWidth)
      return minWidth
    },
    viewDates() {
      if (this.schedule.length === 0) {
        return []
      }
      if (this.startDate == null) {
        return []
      }
      var copiedDate = this.$moment(
        parseDateTimeToLocal(this.startDate + 'T00:00:00')
      )
      return Array.from({ length: this.totalDays }, (_, i) => {
        if (i > 0) {
          copiedDate.add({ day: 1 })
        }
        return copiedDate.format('YYYY-MM-DD')
      })
    },
    viewHours() {
      return Array.from({ length: 24 }, (_, i) => i)
    }
  },
  watch: {
    displayHour() {
      this.getNowStyle()
    },
    totalDays() {
      this.getMinDayCellWidth()
      this.getNowStyle()
    },
    startDate(value) {
      this.startDateObject = parseDateTimeToLocal(value + 'T00:00:00')
      this.getNowStyle()
      this.selectedRooms.length = 0
    },
    displayDate(toDate) {
      if (toDate == null) {
        return
      }
      const scrollPos =
        ((toDate.getTime() - this.startDateObject.getTime()) /
          (60 * 60 * 24 * 1000)) *
        this.dayCellWith
      this.$refs.fcHeader.scrollLeft = scrollPos
    }
  },
  created() {
    this.startDateObject = parseDateTimeToLocal(this.startDate + 'T00:00:00')
    this.startDateObject.setHours(0)
    this.startDateObject.setMinutes(0)
    this.startDateObject.setMilliseconds(0)

    this.nowLabel = this.$moment().format('HH:mm')

    this.nowTimer = setInterval(() => {
      this.nowLabel = this.$moment().format('HH:mm')
      this.getNowStyle()
    }, 60 * 1000)

    this.minDayCellWidth = this.$refs.fcHeader.clientWidth / this.totalDays
  },
  beforeDestroy() {
    clearInterval(this.nowTimer)
  },
  async beforeMount() {
    await this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
      await getUserDetailApi().then(res => {
        this.userGroups = res.data.user.user_group_ids.map(item => item.name)
      })
    },
    onRefresh() {
      this.$emit('refresh')
    },
    onViewBooking(bookingId) {
      this.roomBooking = {
        sub_booking_group_id: bookingId
      }
      // this.isBookingRoomDialogOpened = true
    },
    onAddSelectedCell(room, day, event) {
      if (this.isDayGridEnabled) {
        let isError = false
        for (let i = 0; i < room.type.length; i++) {
          const e = room.type[i]
          if ([4, 5].includes(parseInt(e.type))) {
            continue
          }
          const date_from = e.date_from.split(' ')[0]
          const date_to = e.date_to.split(' ')[0]

          if (day < date_to && day >= date_from) {
            notifyError('Không được chọn ngày này', true)
            isError = true
            break
          }
        }
        if (isError) {
          return
        }
        const offsetTop = event.srcElement.offsetParent.offsetTop
        const offsetLeft = event.srcElement.offsetLeft
        this.onSelectRoomDay(room, day, offsetTop, offsetLeft)
        this.$emit('roomDaySelected', room, day)
      }
    },
    onRemoveSelectedRoom(room, index) {
      const cRoomIndex = this.selectedRooms.findIndex(
        e => e.room.room_id === room.room.room_id
      )
      this.selectedRooms[cRoomIndex].days.splice(index, 1)
      if (this.selectedRooms[cRoomIndex].days.length === 0) {
        this.selectedRooms.splice(cRoomIndex, 1)
      }
    },
    onSelectRoomDay(selectedRoom, day, offsetTop, offsetLeft) {
      const existingRoom = this.selectedRooms.find(
        room => room.roomId === selectedRoom.room_id
      )
      const selectedDay = this.$moment(day)
      if (
        selectedDay.isBefore(
          this.$moment().add(-1, 'days').hours(0).minutes(0).seconds(0)
        )
      ) {
        notifyError('Không thể đặt phòng trong quá khứ', true)
        return
      }
      if (existingRoom) {
        this.addDayToSelectedRoom(
          existingRoom,
          selectedDay,
          offsetTop,
          offsetLeft
        )
      } else {
        this.selectedRooms.push({
          roomId: selectedRoom.room_id,
          room: selectedRoom,
          roomNum: selectedRoom.room_num,
          days: [
            {
              start: selectedDay,
              end: selectedDay.clone(),
              offsetTop: offsetTop,
              offsetLeft: offsetLeft
            }
          ]
        })
      }
    },
    addDayToSelectedRoom(room, day, offsetTop, offsetLeft) {
      const days = room.days
      const selectedDay = this.$moment(day)
      for (let i = 0; i < days.length; i++) {
        if (days.length === 1) {
          if (selectedDay.isSameOrBefore(days[i].start)) {
            const isNextToCurrent = days[i].start.diff(selectedDay, 'days') <= 1
            if (isNextToCurrent) {
              days[i].start = selectedDay
              days[i].offsetTop = offsetTop
              days[i].offsetLeft = offsetLeft
            } else {
              days.unshift({
                start: selectedDay.clone(),
                end: selectedDay.clone(),
                offsetTop: offsetTop,
                offsetLeft: offsetLeft
              })
            }
            break
          } else if (selectedDay.isSameOrAfter(days[i].end)) {
            const isNextToCurrent = selectedDay.diff(days[i].end, 'days') <= 1
            if (isNextToCurrent) {
              days[i].end = selectedDay
            } else {
              days.push({
                start: selectedDay.clone(),
                end: selectedDay.clone(),
                offsetTop: offsetTop,
                offsetLeft: offsetLeft
              })
            }
            break
          }
        }

        const isAddedDayNextToPrevious =
          i > 0 &&
          selectedDay.isSameOrAfter(days[i - 1].end) &&
          selectedDay.diff(days[i - 1].end, 'days') <= 1

        const isAddedDayNextToNext =
          selectedDay.isSameOrBefore(days[i].start) &&
          days[i].start.diff(selectedDay, 'days') <= 1

        if (isAddedDayNextToPrevious && isAddedDayNextToNext) {
          days[i - 1].end = days[i].end
          days.splice(i, 1)
          break
        } else if (isAddedDayNextToPrevious) {
          days[i - 1].end = selectedDay
          break
        } else if (isAddedDayNextToNext) {
          days[i].start = selectedDay
          days[i].offsetTop = offsetTop
          days[i].offsetLeft = offsetLeft
          break
        }

        if (i === days.length - 1) {
          if (selectedDay.isAfter(days[i].end)) {
            if (selectedDay.diff(days[i].end, 'days') <= 1) {
              days[i].end = selectedDay
            } else {
              days.push({
                start: selectedDay.clone(),
                end: selectedDay.clone(),
                offsetTop: offsetTop,
                offsetLeft: offsetLeft
              })
            }
          }
          break
        }
      }
    },
    getMinDayCellWidth() {
      this.minDayCellWidth = Math.floor(
        this.$refs.fcHeader.clientWidth / this.totalDays
      )
      this.selectedRooms.length = 0
    },
    getStatusStyle(data) {
      const property = {
        backgroundColor: null,
        color: null
      }

      if (data === 'VCI' || data === 'OCI') {
        // checked
        property.backgroundColor = '#c3edd9'
        property.color = '#357456'
      } else if (data === 'VD' || data === 'OD') {
        // dirty
        property.backgroundColor = '#ffdfe1'
        property.color = '#f12b37'
      } else if (data === 'OOS' || data === 'OOO') {
        property.backgroundColor = '#cdcccc'
        property.color = '#575757'
      } else {
        // clean
        property.backgroundColor = '#ffecd5'
        property.color = '#ea7e00'
      }
      return `color: ${property.color}; background-color: ${property.backgroundColor}; --status-background-color: ${property.color}`
    },
    getNowStyle() {
      if (!this.displayHour) {
        this.nowStyle = 'display: none'
        return
      }
      const nowTime = new Date()
      const endDate = this.$moment(this.startDateObject).add(
        this.totalDays - 1,
        'days'
      )
      console.debug('endDate', nowTime.getTime() > endDate.toDate().getTime())
      if (nowTime.getTime() > endDate.toDate().getTime()) {
        this.nowStyle = 'display: none'
        return
      }

      const startTime = this.startDateObject.getTime()
      const startPos = Math.floor(
        ((nowTime - startTime) / (60 * 60 * 24 * 1000)) * this.dayCellWith
      )

      this.nowStyle = `left: ${startPos + 1}px; z-index: ${startPos}`
    },
    onHeaderScroll(e) {
      if (this.preventEvent) {
        this.preventEvent = false
        return
      }
      this.preventEvent = true
      this.$refs.fcContent.scrollLeft = e.target.scrollLeft
    },
    onContentScroll(e) {
      if (this.preventEvent) {
        this.preventEvent = false
        return
      }

      if (e.target.scrollTop !== this.contentLastScrollTop) {
        this.preventEvent = true
        this.$refs.fcSidebar.scrollTop = e.target.scrollTop
        this.contentLastScrollTop = e.target.scrollTop
      }
      if (e.target.scrollLeft !== this.contentLastScrollLeft) {
        this.preventEvent = true
        this.$refs.fcHeader.scrollLeft = e.target.scrollLeft
        this.contentLastScrollLeft = e.target.scrollLeft
      }
    },
    onSidebarScroll(e) {
      if (this.preventEvent) {
        this.preventEvent = false
        return
      }
      this.preventEvent = true
      this.$refs.fcContent.scrollTop = e.target.scrollTop
    }
  }
}
</script>
<style lang="scss">
.fc-datagrid-days--day-grid-enabled {
  .fc-event-group {
    z-index: 20;
    position: relative;
  }
  .fc-cell--hours-group {
    z-index: 10;
    position: relative;
    &:hover {
      outline: 2px solid rgb(var(--das-color-primary));
      z-index: 200;
      background-color: rgba(var(--das-color-primary), 0.4);
    }
    &--selected {
      background-color: rgba(var(--das-color-primary), 0.4);
    }
  }
}
.fc-datagrid-header-date-cell {
  border-right: var(--border);
}
.fc {
  --das-fc-sidebar-width: 160px;
  --das-fc-cell-width: 2px;
  --das-fc-day-width: 240px;
  --das-fc-cell-height: 36px;
  --border: 1px solid var(--das-border-color);
  font-size: 14px;
  &-cell {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    height: var(--das-fc-cell-height);
    border-bottom: var(--border);

    min-height: 0;
  }

  &-cell-content {
    padding: 8px 12px;
    white-space: nowrap;
    overflow-x: hidden;
    max-width: 100%;
    user-select: none;
  }
  &-container {
    width: 100%;
    display: grid;
    grid-template-columns: var(--das-fc-sidebar-width) 1fr;
    grid-template-rows: min-content 1fr;
    height: 100%;
  }
  &-sidebar {
    .fc-cell--item {
      border-right: var(--border);
    }
    &-header {
      background-color: rgb(var(--das-color-primary));
      color: white;
      font-weight: 700;
      overflow-x: scroll;
      .fc-cell--item {
        display: grid;
      }
      border-right: var(--border);
    }
    &-days {
      .fc-cell--item {
        display: grid;
      }
      overflow: scroll;
    }
  }
  .fc-cell--group {
    cursor: pointer;
    background-color: rgba(var(--das-color-primary), 0.1);
    color: rgb(var(--das-color-primary));
    font-weight: 500;
    border-right: var(--border);
  }
  &-datagrid {
    &-header {
      font-weight: 700;

      .fc-cell--hours-group {
        color: rgba(var(--das-color-primary), 1);
        background-color: rgba(var(--das-color-primary), 0.1);
      }
      .fc-datagrid-header-date-cell {
        color: white;
        background-color: rgba(var(--das-color-primary), 1);
      }
      .fc-datagrid-header-date {
        width: var(--das-fc-day-width);
      }

      overflow: scroll;
      display: flex;
      flex-direction: row;
      > * {
        flex-shrink: 0;
        flex-grow: 0;
      }
    }
    &-days {
      position: relative;
      display: grid;
      grid-auto-flow: row;
      min-height: 0;
      overflow: scroll;
      z-index: 20;
    }
  }
}
.fc-row-group {
  background-color: white;
}
.fc-row {
  display: flex;
  flex-direction: row;
  justify-content: start;
  position: relative;
  overflow-x: clip;
}
.fc-cell_room-num {
  overflow: clip;
  text-overflow: ellipsis;
}
.fc-cell--hours-group {
  border-right: var(--border);
  position: relative;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  height: 100%;
  width: var(--das-fc-day-width);
}
.fc_icon-group-toggle {
  margin-right: 8px;
}
.schedule-room-status_indicator {
  display: inline-block;
  height: 12px;
  height: 12px;
  width: 12px;
  border-radius: 4px;
  background-color: var(--status-background-color);
}
.schedule-room-status {
  display: flex;
  flex-direction: row;
  line-height: 0;
  align-items: center;
  gap: 8px;
}
.fc-display-hour .fc-cell-hour {
  display: grid;
  align-items: center;
  justify-content: start;
  height: 100%;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  box-sizing: border-box;
  border-right: var(--border);
  border-right-style: dashed;
  &:last-child {
    border-right: none;
  }
  > * {
    padding: 0 4px;
  }
}
.fc-display-day .fc-cell-hour {
  display: none;
}
.sticky {
  position: sticky;
  top: 0;
  background-color: white !important;
}
.fc-time-indicators {
  z-index: 10;
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  display: flex;
  flex-direction: row;
  .fc-row {
    display: grid;
    grid-template-columns: repeat(24, 1fr);
  }
}
.fc-row.fc-cell:hover .fc-event:hover {
  z-index: 99999999 !important;
}
.fc-display-day .fc-time-indicators {
  display: none;
}
.fc-time-indicators .fc-time-indicator:not(:first-child) {
  height: 100%;
  z-index: 10;
  width: 1px;
  border-left: var(--border);
  border-width: 1px;
  border-left-style: dashed;
  &:hover {
    border-color: rgb(var(--das-color-amber));
  }
}
.fc-now-indicator {
  position: absolute;
  height: 100%;
  border-left: 1px solid rgb(var(--das-color-amber));
  color: rgb(var(--das-color-amber));
  z-index: 40;
  width: 0px;
  left: 20px;
  .fc-now-indicator_time {
    background-color: rgb(var(--das-color-amber));
    color: white;
    position: sticky;
    top: 4px;
    padding: 0 6px;
    font-size: 10px;
    font-weight: 500;
    display: block;
    padding: 4px 6px;
    line-height: 10px;
    margin-left: 4px;
    border-radius: 4px;
    opacity: 0.6;
    width: fit-content;
  }
}
.fc-datagrid-header-date-cell {
  .fc-cell-content {
    width: 100%;
  }
}
.fc-datagrid-header-label {
  position: sticky;
  display: inline-block;
  top: 0;
  left: 0;
}
.fc-cell--today {
  background-color: rgb(var(--das-color-amber)) !important;
}
.fc-cell--today.fc-cell--hours-group {
  background-color: rgba(var(--das-color-amber), 0.1) !important;
}
</style>
